import { CombinedGraphQLErrors, ServerError } from '@apollo/client/errors';
import { onError } from '@apollo/client/link/error';
import { datadogLogs } from '@datadog/browser-logs';
import { Observable } from 'rxjs';

export const createErrorLink = (onUnauthenticatedError: () => Promise<void>) =>
  onError(({ error, operation }) => {
    if (CombinedGraphQLErrors.is(error)) {
      // We're being defensive here because we've seen situtations where `graphQLErrors` is not
      // actually an array of `GraphQLFormattedError`.
      error.errors.forEach(gqlError => {
        datadogLogs.logger.error('WebGraphQLLatencyMetric', {
          name: '[GraphQL Error]',
          message: gqlError.message,
          locations: gqlError.locations,
          path: gqlError.path,
        });
      });
    }

    if (ServerError.is(error) && error.statusCode === 401) {
      // If the network error is a 401, we want to log it and trigger the unauthenticated error handler.
      // This is an "expected" error in the sense that it indicates the user is not authenticated,
      // so we handle it differently than other errors, not capturing it with Sentry
      datadogLogs.logger.error('WebGraphQLNetworkError', {
        name: '[401 Error]',
        message: `operationName: ${operation.operationName} message: ${error.message}`,
      });

      return new Observable(observer => {
        onUnauthenticatedError()
          .then(() => {
            observer.complete();
          })
          .catch(err => {
            observer.error(err);
          });
      });
    }

    return undefined;
  });
